import { render, staticRenderFns } from "./OriginatingFeesReport.vue?vue&type=template&id=559ecd8b&"
import script from "./OriginatingFeesReport.vue?vue&type=script&lang=js&"
export * from "./OriginatingFeesReport.vue?vue&type=script&lang=js&"
import style0 from "./OriginatingFeesReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports